import React, {Component} from 'react'
import {Row, Col} from 'reactstrap'
import PropTypes from 'prop-types'
import moment from 'moment'
const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

export default class UserRoleRatesListItem extends Component{

    render(){

        const {
            mon,
            tue,
            wed,
            thu,
            fri,
            sat,
            sun,
            activeFrom
        } = this.props

        return (
            <tr>
                <td>{format(mon.hourly_rate)}</td>
                <td>{format(tue.hourly_rate)}</td>
                <td>{format(wed.hourly_rate)}</td>
                <td>{format(thu.hourly_rate)}</td>
                <td>{format(fri.hourly_rate)}</td>
                <td>{format(sat.hourly_rate)}</td>
                <td>{format(sun.hourly_rate)}</td>
                <td>{moment(activeFrom).format('DD/MM/YYYY')}</td>
            </tr>
        )
    }

}

UserRoleRatesListItem.propTypes = {
    mon: PropTypes.string,
    tue: PropTypes.string,
    wed: PropTypes.string,
    thu: PropTypes.string,
    fri: PropTypes.string,
    sat: PropTypes.string,
    sun: PropTypes.string,
    activeFrom: PropTypes.string
}